module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid13_800x800.56e88c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid13_800x800.jpg
// module id = kx9A
// module chunks = 0